import { render, staticRenderFns } from "./BarTitle.vue?vue&type=template&id=19442395&scoped=true&"
var script = {}
import style0 from "./BarTitle.scss?vue&type=style&index=0&id=19442395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../home/gitlab-runner/.nvm/versions/node/v12.14.1/lib/node_modules/@briskly/vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19442395",
  null
  
)

export default component.exports